jQuery( $ => {
	// Wait for the document to be fully loaded
	$( document ).ready( function() {
		resetShippingAddressCheckbox();
	} );

	/**
	 * Wait with execution of a function.
	 *
	 * Use like so: await waitWithExecution( 300 );
	 *
	 * @param {number} ms - The number of milliseconds to wait.
	 * @return {Promise<void>}
	 */
	function waitWithExecution( ms ) {
		return new Promise( resolve => setTimeout( resolve, ms ) );
	}

	/**
	 * Here we check if there are KCO params on the page but the form does not use the kco class.
	 * If so, it's very likely that KCO is not used which happens when an order cost is equal to 0.
	 * In that case, we reset the shipping address checkbox.
	 * KCO sets it always right now and does so incorrectly here: site/public/wp-content/plugins/klarna-checkout-for-woocommerce/assets/js/klarna-checkout-for-woocommerce.js
	 *
	 */
	async function resetShippingAddressCheckbox() {
		await waitWithExecution( 300 ); // Pause for .3 seconds, so that the other javascript from Klarna can execute first.

		const kcoExists = window.kco_params ?? false;
		const checkoutFormWithKco = document.querySelector( 'form.woocommerce-checkout' )?.classList.contains( 'kco-checkout' ) ?? false;

		if ( kcoExists && ! checkoutFormWithKco ) {
			console.log( 'Resetting shipping address checkbox because KCO incorrectly checks it.' ); // eslint-disable-line no-console
			const shippingCheckbox = $( '#ship-to-different-address-checkbox' );
			if ( shippingCheckbox.length ) {
				shippingCheckbox.prop( 'checked', false );
			}
		}
	}
} );
